import React, { Component } from 'react';
import { withContext } from '../utils/StateProvider';
import ExplorationActionPanel from './explorationActionPanel';
import CombatActionPanel from './combatActionPanel';
import SpellMenu from './spellMenu';

class ActionPanel extends Component {
  render() {
    const { spellcasting, combat } = this.props.context;
    if (spellcasting) return <SpellMenu />;
    return combat ? <CombatActionPanel /> : <ExplorationActionPanel />;
  }
}

export default withContext(ActionPanel);
